module.exports = __webpack_public_path__ + "static/img/banner.88d31e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.jpg
// module id = hKcQ
// module chunks = 12